<mat-card class="card-style px-6 py-6 pt-0 h-full">
  <mat-card-header class="flex justify-between items-center gap-2">
    <div class="flex-1">
      <mat-card-title class="">Criar Cotação</mat-card-title>
    </div>
    <button mat-flat-button class="btn-tg-cancel w-1/12" (click)="close()">
      Cancelar
    </button>
    <button
      mat-flat-button
      class="btn-tg w-1/12"
      [disabled]="!checkModel() || loading"
      (click)="createPrice()"
    >
      @if (loading) {
        <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
      } @else {
        Criar
      }
    </button>
  </mat-card-header>
  <mat-accordion class="example-headers-align mt-6" multi>
    <mat-expansion-panel expanded>
      <mat-expansion-panel-header>
        <mat-panel-title> Proposta </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="flex justify-between gap-4 mb-4">
        <div class="w-1/4"><b>tg cod:</b> {{ itemEdit.tg }}</div>
        <div class="w-3/4"><b>Evento:</b> {{ itemEdit.nomeEvento }}</div>
      </div>
      <div class="flex justify-between gap-4 mb-4">
        <div class="w-1/3">
          <b>
            {{
              itemEdit.nomeSubCliente && itemEdit.nomeSubCliente != ''
                ? 'Subcliente'
                : 'Cliente'
            }}:
          </b>
          {{
            itemEdit.nomeSubCliente && itemEdit.nomeSubCliente != ''
              ? itemEdit.nomeSubCliente
              : itemEdit.nomeCliente
          }}
        </div>
        <div class="w-1/3">
          <b>Solicitante:</b> {{ itemEdit.nomeConsultor ?? '-' }}
        </div>
        <div class="w-1/3">
          <b>Consultor Comercial:</b> {{ itemEdit.consultorComercial }}
        </div>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel expanded>
      <mat-expansion-panel-header>
        <mat-panel-title> Solicitação </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="mb-6">
        <mat-accordion>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title> Pesquisa </mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <!--            <form-search-proposal-client-->
              <!--              [search]="inputSearch"-->
              <!--              (responseSearch)="search($event)"-->
              <!--            />-->
              <form-search-quote-request-modal-tg-new
                [search]="inputSearch"
                (responseSearch)="search($event, 'purchases')"
              />
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
      <div class="mt-2">
        <div class="overflow-purchases">
          @if (!loadingPurchases) {
            <table-list-select-purchases-new
              [dataSource]="itemsList"
              [columns]="columns"
              [multiSelect]="multiSelect"
              [selected]="selected"
              [listSelected]="listSelected"
              (selectItem)="selectItem($event, 'purchases')"
              (itinerariesItem)="viewItinerariesItem($event)"
            />
          } @else {
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          }
        </div>
        <mat-paginator
          [hidden]="loadingPurchases"
          #paginatorPurchases
          [pageSize]="rows"
          [pageIndex]="page - 1"
          [pageSizeOptions]="[5, 10, 20]"
          (page)="pageChanged($event, 'purchases')"
          [length]="numberRows"
        >
        </mat-paginator>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel expanded>
      <mat-expansion-panel-header>
        <mat-panel-title> Fornecedor </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="flex justify-end">
        <div class="mr-8">
          <button mat-raised-button class="btn-add" (click)="newSupplier()">
            Novo Fornecedor
          </button>
        </div>
      </div>
      <form-client-search
        [search]="inputSearch"
        [listSearch]="listSearch"
        (responseSearch)="search($event, 'supplier')"
      />
      <div class="mt-2">
        <div class="overflow-purchases">
          @if (!loadingSupplier) {
            <table-list-select-purchases
              [dataSource]="itemsListSupplier"
              [columns]="columnsSupplier"
              [multiSelect]="multiSelect"
              [selected]="selectedSupplier"
              [listSelected]="listSelectedSupplier"
              (selectItem)="selectItem($event, 'supplier')"
            />
          } @else {
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          }
        </div>
        <mat-paginator
          [hidden]="loadingSupplier"
          #paginatorSupplier
          [pageSize]="rowsSupplier"
          [pageIndex]="pageSupplier - 1"
          [pageSizeOptions]="[5, 10, 20]"
          (page)="pageChanged($event, 'supplier')"
          [length]="numberRowsSupplier"
        >
        </mat-paginator>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</mat-card>
